import { useState } from 'react'
import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './WhiteLabelCheckoutModal.module.scss'

interface WhiteLabelCancelModalProps {
  onConfirm: () => void
  onCancel?: () => void
}

export const WhiteLabelCancelModal = ({ onConfirm, onCancel }: WhiteLabelCancelModalProps) => {
  const [isProcessing, setIsProcessing] = useState(false)

  const handleConfirm = async () => {
    setIsProcessing(true)
    try {
      await onConfirm()
    } finally {
      setIsProcessing(false)
    }
  }

  return (
    <Modal.Root size="sm" bodyClassName={Styles.modal}>
      <Modal.Content>
        <div className={Styles.header}>
          <Heading level={3}>Turn off White Label?</Heading>
        </div>

        <div className={Styles.content}>
          <Text variant="primary" color="var(--dark-80)">
            White Label will be disabled, and Blaze branding will return. Any unused time on your White Label add-on
            subscription will be credited on your next invoice.
          </Text>
        </div>

        <div className={Styles.footer}>
          <Button variant="secondary" size="lg" onPress={onCancel} isDisabled={isProcessing}>
            Keep White Label
          </Button>
          <Button variant="primary" size="lg" onPress={handleConfirm} isDisabled={isProcessing}>
            {isProcessing ? 'Processing...' : 'Turn Off White Label'}
          </Button>
        </div>
      </Modal.Content>
    </Modal.Root>
  )
}
